import { render, staticRenderFns } from "./LinkWrap.vue?vue&type=template&id=14aa9270&scoped=true&"
import script from "./LinkWrap.vue?vue&type=script&lang=js&"
export * from "./LinkWrap.vue?vue&type=script&lang=js&"
import style0 from "./LinkWrap.vue?vue&type=style&index=0&id=14aa9270&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14aa9270",
  null
  
)

export default component.exports